import { HardwireLogo } from './HardwireMark';

export const Brand = ({ size = 36, showText = true, subtitle = false, tone = 'dark' }) => (
  <div data-testid="brand-logo">
    <HardwireLogo size={showText ? size * 1.1 : size} variant={showText ? 'horizontal' : 'mark'} tone={tone} testId={showText ? 'brand-supplied-logo' : 'brand-mark'} />
    {subtitle && <p className="mt-3 text-xs tracking-wide text-slate-300">Customer, builder & team workspace</p>}
  </div>
);
